// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Axk2M","colBig":"styles_colBig__ECpQM","colSmall":"styles_colSmall__a6djt"};